export const languageReadableMapLambda = {
    'Plaintext': 'plaintext',
    'Python 3.12': 'python',
    'Java 21': 'java',
    'Node.js 22': 'javascript'
  };  